(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eluna-page-jump"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eluna-page-jump')) {
    customElements.define('eluna-page-jump', class extends HTMLElement {
      connectedCallback() {
        this.update = () => {
          const end = document.documentElement.scrollHeight - window.innerHeight;
          this.hidden = end < 160;
          this.querySelector('[data-direction=top]').setAttribute('aria-disabled', String(window.scrollY < 16));
          this.querySelector('[data-direction=bottom]').setAttribute('aria-disabled', String(window.scrollY >= end - 16));
        };
        this.onScroll = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); }); };
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || button.getAttribute('aria-disabled') === 'true') return;
          if (button.dataset.direction === 'bottom') {
            window.addEventListener('scrollend', () => {
              const remaining = document.documentElement.scrollHeight - innerHeight - scrollY;
              if (remaining > 0 && remaining < 200) window.scrollTo({top:document.documentElement.scrollHeight,behavior:'instant'});
            }, {once:true});
          }
          window.scrollTo({top: button.dataset.direction === 'top' ? 0 : document.documentElement.scrollHeight, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        });
        window.addEventListener('scroll', this.onScroll, {passive:true});
        window.addEventListener('resize', this.onScroll);
        this.observer = new ResizeObserver(this.onScroll);
        this.observer.observe(document.body);
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.observer.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
